import axiosClient from '../../client/axiosClient';
import { API_ENDPOINTS } from '../../endpoints/endpoints';

export const AdminApi = {
  // 클라이언트 IP 주소 조회
  getClientIp: async () => {
    const response = await axiosClient.get('/admin/auth/ip');
    return response.data;
  },

  // 관리자 로그인
  login: async (loginData) => {
    const response = await axiosClient.post(API_ENDPOINTS.LOGIN, loginData);
    return response.data;
  },

  // 첫 로그인 확인
  checkFirstLogin: async () => {
    const response = await axiosClient.get(API_ENDPOINTS.CHECK_FIRST_LOGIN);
    return response.data;
  },

  // 관리자 목록 조회
  getAdminList: async (params = {}) => {
    const response = await axiosClient.get('/admin/users', { params });
    return response.data;
  },

  // 관리자 상세 조회
  getAdminDetail: async (id) => {
    const response = await axiosClient.get(`/admin/users/${id}`);
    return response.data;
  },

  // 관리자 생성
  createAdmin: async (adminData) => {
    const response = await axiosClient.post('/admin/users', adminData);
    return response.data;
  },

  // 관리자 수정
  updateAdmin: async (id, adminData) => {
    const response = await axiosClient.put(`/admin/users/${id}`, adminData);
    return response.data;
  },

  // 관리자 삭제
  deleteAdmin: async (id) => {
    const response = await axiosClient.delete(`/admin/users/${id}`);
    return response.data;
  },

  // 관리자 비밀번호 변경
  changePassword: async (id, passwordData) => {
    const response = await axiosClient.patch(`/admin/users/${id}/password`, passwordData);
    return response.data;
  },

  // 관리자 상태 변경
  updateAdminStatus: async (id, status) => {
    const response = await axiosClient.patch(`/admin/users/${id}/status`, { status });
    return response.data;
  },

  // 알림 가져오기 (NotificationBell.js에서 사용)
  getNotifications: async (recipient) => {
    const response = await axiosClient.get(`/admin/notifications?recipient=${recipient}`);
    return response.data;
  },

  // 읽지 않은 알림 수 가져오기 (NotificationBell.js에서 사용)
  getUnreadCount: async (recipient) => {
    const response = await axiosClient.get(`/admin/notifications/unread-count?recipient=${recipient}`);
    return response.data;
  },

  // 알림 읽음 처리 (NotificationBell.js에서 사용)
  markNotificationAsRead: async (id, recipient) => {
    const response = await axiosClient.post(`/admin/notifications/read/${id}?recipient=${recipient}`);
    return response.data;
  },

  // 모든 알림 읽음 처리 (NotificationBell.js에서 사용)
  markAllNotificationsAsRead: async (recipient) => {
    const response = await axiosClient.post(`/admin/notifications/read-all?recipient=${recipient}`);
    return response.data;
  },

  // 알림 삭제 (NotificationBell.js에서 사용)
  deleteNotification: async (id, recipient) => {
    const response = await axiosClient.delete(`/admin/notifications/${id}?recipient=${recipient}`);
    return response.data;
  },

  // 모든 알림 삭제 (NotificationBell.js에서 사용)
  deleteAllNotifications: async (recipient) => {
    const response = await axiosClient.delete(`/admin/notifications/delete-all?recipient=${recipient}`);
    return response.data;
  },

  // 시스템 상태 조회 (AdminLogin.js에서 사용)
  getSystemStatus: async () => {
    const response = await axiosClient.get(API_ENDPOINTS.SYSTEM_STATUS);
    return response.data;
  },

  // 테스트용 알림 생성
  createTestNotification: async (recipient, link = null) => {
    const response = await axiosClient.post(`/admin/notifications/test?recipient=${recipient}${link ? `&link=${link}` : ''}`);
    return response.data;
  },

  // 테스트용 고정 알림 생성
  createTestPinnedNotification: async (recipient) => {
    const response = await axiosClient.post(`/admin/notifications/test-pinned?recipient=${recipient}`);
    return response.data;
  },

  // 관리자 게시판 API
  // 게시글 목록 조회
  getAdminPosts: async (page = 0, size = 10, category = '', keyword = '') => {
    const params = new URLSearchParams({
      page: page.toString(),
      size: size.toString()
    });
    if (category) params.append('category', category);
    if (keyword) params.append('keyword', keyword);
    
    const response = await axiosClient.get(`/admin/posts?${params}`);
    return response.data;
  },

  // 게시글 상세 조회
  getAdminPost: async (id) => {
    const response = await axiosClient.get(`/admin/posts/${id}`);
    return response.data;
  },
  
  // 게시글 조회 (조회수 증가 포함)
  getAdminPostWithView: async (id, userId = null, userIp = null) => {
    const params = new URLSearchParams();
    if (userId) params.append('userId', userId);
    if (userIp) params.append('userIp', userIp);
    
    const response = await axiosClient.post(`/admin/posts/${id}/view?${params}`);
    return response.data;
  },

  // 게시글 생성
  createAdminPost: async (postData) => {
    const response = await axiosClient.post('/admin/posts', postData);
    return response.data;
  },

  // 게시글 수정
  updateAdminPost: async (id, postData) => {
    const response = await axiosClient.put(`/admin/posts/${id}`, postData);
    return response.data;
  },

  // 게시글 삭제
  deleteAdminPost: async (id) => {
    const response = await axiosClient.delete(`/admin/posts/${id}`);
    return response.data;
  },

  // 최신 게시글 조회 (대시보드용)
  getLatestAdminPosts: async (limit = 5) => {
    const response = await axiosClient.get(`/admin/posts/latest?limit=${limit}`);
    return response.data;
  },

  // 고정글 조회
  getPinnedAdminPosts: async () => {
    const response = await axiosClient.get('/admin/posts/pinned');
    return response.data;
  },


  // 공지사항 조회
  getNotices: async (limit = 5) => {
    const response = await axiosClient.get(`/admin/posts/notices?limit=${limit}`);
    return response.data;
  },

  // 업데이트 조회
  getUpdates: async (limit = 5) => {
    const response = await axiosClient.get(`/admin/posts/updates?limit=${limit}`);
    return response.data;
  }
};